<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование организации" : "Добавление организации"'
  )
  v-card
    v-tabs(v-model='active' color='dark' slider-color='primary')
      v-tab Организация
      v-tab-item(:transition='false' :reverse-transition='false')
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs6)
              v-text-field(
                :error='errors.has("name")'
                :error-messages='errors.first("name")'
                v-model='item.name'
                label='Название / Торговое название'
              )
            v-flex(xs6)
              s-org-spheres-picker(
                :error='errors.has("sphere_id")'
                :error-messages='errors.first("sphere_id")'
                v-model='item.sphere_id'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("full_name")'
                :error-messages='errors.first("full_name")'
                v-model='item.full_name'
                label='Полное название / Юридическое название'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("site")'
                :error-messages='errors.first("site")'
                v-model='item.site'
                label='Сайт'
              )
            v-flex(xs6)
              v-text-field(
                :error='errors.has("email")'
                :error-messages='errors.first("email")'
                v-model='item.email'
                label='Email'
              )
            v-flex(xs12)
                span(class='subheading font-weight-medium') Контактные телефоны
                v-btn(@click='onAddContact' small flat color='primary')
                  v-icon(small left) add
                  | Добавить
            v-flex(xs12)
              v-layout(wrap)
                v-flex(
                  v-for='(phone, index) in phones'
                  :key='index'
                  xs12 md3
                )
                  s-phone-input(
                    @input='onContactChange($event, index)'
                    @click:append='onRemoveContact(index)'
                    :value='phone'
                    label='Номер телефона'
                    append-icon='close'
                  )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("about")'
                :error-messages='errors.first("about")'
                v-model='item.about'
                label='Описание'
              )
            v-flex(xs12 sm4)
              s-image-upload(
                :src='item.avatar_url'
                v-model='item.avatar'
                label='Логотип'
              )
        v-card-actions(class='large')
          v-spacer
          s-back-btn
          v-btn(
            :loading='isLoading'
            @click='onSave'
            color='primary'
            depressed
          ) Сохранить
      template(v-if='id')
        v-tab Офисы
        v-tab-item(:transition='false' :reverse-transition='false')
          s-offices-list(
            @edit='editOffice'
            @delete='deleteOffice'
            :list='item.offices'
            :flat='true'
          )
      template(v-if='id')
        v-tab Пользователи
        v-tab-item(:transition='false' :reverse-transition='false')
          s-users-list(
            @edit='editUser'
            @delete='deleteUser'
            :list='item.users'
            :editable='false'
            :flat='true'
          )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  data: () => ({
    item: {},
    active: 0,
    phones: [null],
    maxPhones: 10
  }),

  created() {
    this.updateItem()
  },

  methods: {
    async updateItem() {
      if (this.id) {
        let { data } = await this.fetchSingle({ id: this.id })
        this.item = data
        this.phones = this.item.phones.split(/,/)
      }
    },

    async onSave() {
      let data = this.createFormData(this.item)
      data.append('avatar', this.item.avatar)
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data
          })
        } else {
          await this.create({ data })
        }

        this.$root.showSnack('Компания сохранена')
        this.$router.push({ name: 'Partners.Organizations' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    createFormData() {
      let data = new FormData()

      if (this.phones.length) {
        this.item.phones = this.phones.filter(c => c).join(',')
      } else {
        this.item.phones = null
      }

      Object.keys(this.item).forEach(key => {
        data.append(key, this.item[key])
      })

      return data
    },

    onContactChange(value, index) {
      this.phones[index] = value
    },

    onRemoveContact(index) {
      this.phones.splice(index, 1)
    },

    onAddContact() {
      if (this.phones.length < this.maxPhones) {
        this.phones.push(null)
      }
    },
    editOffice(id) {
      this.$router.push({
        name: 'Partners.Organizations.Offices.Edit',
        params: { organizationId: this.id, id }
      })
    },

    async deleteOffice(id) {
      if (!this.isOfficeLoading && (await this.$confirm('Вы уверены?'))) {
        try {
          await this.destroyOffice({ id })
          this.updateItem()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    editUser(id) {
      if (!id) {
        this.$router.push({
          name: 'Partners.Organizations.Users.Edit',
          params: { organizationId: this.id }
        })
      }
    },

    async deleteUser(id) {
      if (!this.isUserLoading && (await this.$confirm('Вы уверены?'))) {
        try {
          await this.destroyUser(this.findUser(id).pivot)
          this.updateItem()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    findUser(id) {
      return this.item.users.find(x => x.id === id)
    },

    ...mapActions('partners/organizations', [
      'fetchSingle',
      'update',
      'create'
    ]),
    ...mapActions('partners/offices', { destroyOffice: 'destroy' }),
    ...mapActions('partners/users', { destroyUser: 'destroy' })
  },

  computed: {
    ...mapGetters('partners/organizations', ['isLoading']),
    ...mapGetters('partners/offices', { isOfficeLoading: 'isLoading' }),
    ...mapGetters('partners/users', { isUserLoading: 'isLoading' })
  }
}
</script>
